module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/timeline_2-f4de3cc4cb3219f5b96e01334bf43f5d.svg";